import icons from "@/components/icons/generated/icons.generated.json";
import iconsUrl from "@/components/icons/generated/icons.generated.svg";

export type IconName = keyof typeof icons;

export function createIcon(name: IconName, attrs?: Record<string, string>): SVGSVGElement | null {
  const size = icons[name] as [number, number] | undefined;

  if (!size) {
    return null;
  }

  const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  svg.setAttribute("viewBox", `0 0 ${size[0]} ${size[1]}`);
  svg.setAttribute("width", `${size[0]}`);
  svg.setAttribute("height", `${size[1]}`);

  for (const [key, value] of Object.entries(attrs ?? {})) {
    svg.setAttribute(key, value);
  }

  const use = document.createElementNS("http://www.w3.org/2000/svg", "use");
  use.setAttribute("href", `${iconsUrl}#icon-${name}`);
  svg.appendChild(use);

  return svg;
}
